import { StatusTag } from "@graffer-inc/console-design-kit";
import * as React from "react";
import { PublishStatus } from "../../application/domain/procedures/procedure-entity";

type ProcedureStatusTagProps = {
  status: PublishStatus;
};

export const ProcedureStatusTag: React.FC<ProcedureStatusTagProps> = ({
  status,
}) => {
  switch (status) {
    case "DRAFT":
      return <StatusTag type={"SECONDARY"}>下書き</StatusTag>;
    case "BEFORE_PUBLISH":
      return <StatusTag type={"LIGHT"}>公開前</StatusTag>;
    case "BEFORE_ACCEPTING":
      return <StatusTag type={"LIGHT"}>受付前</StatusTag>;
    case "ACCEPTING":
      return (
        <StatusTag type={"SUCCESS"} hiddenCheckIcon>
          受付中
        </StatusTag>
      );
    case "PAUSING_ACCEPT":
      return <StatusTag type={"WARN"}>受付停止中</StatusTag>;
    case "FINISHED_ACCEPTING":
      return <StatusTag type={"DARK"}>受付終了</StatusTag>;
    case "UNPUBLISHED":
      return <StatusTag type={"DARK"}>公開終了</StatusTag>;
  }
};
